<div class="pageheader">
    <div class="page-title">
        <h1>Identity tokens</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-6 col-md-3">
        <ep-identity-token-amount-selector #identityTokenAmountSelector (selectedIdentityAmountChange)="identityAmountChanged()"></ep-identity-token-amount-selector>
    </div>
</div>



<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='tokenview' [bizSetColumnChooser]="true"
              [bizSetAllowColumnReordering]="false" [bizSetSearchPanel]="true" [bizSetPager]="true" >

    <dxo-editing mode="row">
        <dxo-popup title="Identity tokens" [showTitle]="true"></dxo-popup>
    </dxo-editing>

    <!-- <dxi-column dataField="Id" caption="Id" dataType="string" sortOrder="asc"></dxi-column> -->
    <dxi-column dataField="Application_ClientID" caption="Client Id" dataType="string"></dxi-column>
    <dxi-column dataField="Application_DisplayName" caption="Display Name" dataType="string"></dxi-column>
    <dxi-column dataField="Token_ConcurrencyToken" caption="Concurrency Token" dataType="string"></dxi-column>
    <dxi-column dataField="Token_CreationDate" caption="Creation Date" dataType="datetime"></dxi-column>
    <dxi-column dataField="Token_ExpirationDate" caption="Expiration Date" dataType="datetime" ></dxi-column>
    <dxi-column dataField="Token_Payload" caption="Payload" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="Token_Properties" caption="Properties" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="Token_RedemptionDate" caption="Redemption Date" dataType="datetime" [visible]="false"></dxi-column>
    <dxi-column dataField="Token_Status" caption="Status" dataType="string"></dxi-column>
    <dxi-column dataField="Token_Subject" caption="subject" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="User_DisplayName" caption="User" dataType="string"></dxi-column>
    <dxi-column dataField="Token_Type" caption="Token Type" dataType="string"></dxi-column>
    <dxi-column dataField="Token_ReferenceId" caption="ReferenceId" dataType="string" [visible]="false"></dxi-column>

</dx-data-grid>



